import { useEffect, useState } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { hbAdComponents, HbAdType } from '@/components/ads-components/hb-agency/hb-ad';
import useIsUserPremium from '@/DesignSystem/hooks/useIsUserPremium';
import useIsProduction from '@/DesignSystem/hooks/useIsProduction';

const TOP_AD_UNIT_ID = {
    mobile: 'hbagency_space_176437',
    desktop: 'hbagency_space_177071',
};

const retryDelays = [5000, 7000, 15000, 30000]; // ms

const TopAd = () => {
    const isDesktopRaw = useMediaQuery('(min-width: 600px)', { noSsr: true });
    const [hydrated, setHydrated] = useState(false);
    const isPremium = useIsUserPremium();
    const isProduction = useIsProduction();

    useEffect(() => {
        setHydrated(true);
    }, []);

    const adId = isDesktopRaw ? TOP_AD_UNIT_ID.desktop : TOP_AD_UNIT_ID.mobile;

    useEffect(() => {
        if (!hydrated) return;

        const timeouts = retryDelays.map((delay, index) =>
            setTimeout(() => {
                const hbElement = document.getElementById(adId);
                const isEmpty =
                    hbElement &&
                    (hbElement.innerHTML.trim() === '' ||
                        hbElement.offsetHeight === 0 ||
                        hbElement.children.length === 0);

                if (isEmpty) {
                    try {
                        if (window.hbManager?.refreshBidHBA) {
                            window.hbManager.refreshBidHBA(adId);
                        }
                    } catch (e) {
                        console.error(`❌ Error al refrescar HB (${adId}) en intento ${index + 1}:`, e);
                    }
                }
            }, delay)
        );

        return () => timeouts.forEach(clearTimeout);
    }, [adId, hydrated]);

    if (!hydrated) return <Box sx={{ width: '100%', minHeight: '250px' }}></Box>;

    if (isPremium || !isProduction) return null;

    return (
        <Box className="container" sx={{ width: '100%', minHeight: isDesktopRaw ? '250px' : '100px' }}>
            {isDesktopRaw ? hbAdComponents[HbAdType.BILLBOARD] : hbAdComponents[HbAdType.AF_300x100_MOBILE]}
        </Box>
    );
};

export default TopAd;
